// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"tab-bar_tabBar__hQOBZ","tabList":"tab-bar_tabList__x6bSQ"};